<div class="dx-fieldset" style="max-width: 800px;">
  <div class="dx-field">
    <div class="dx-field-label">Thèmes</div>
    <div class="dx-field-value theme-selector-wrapper">
      <dx-select-box class="theme-select-box" [items]="themeList" [(value)]="selectedThemeId" valueExpr="id"
        displayExpr="text" (onValueChanged)="onThemeChange($event)"></dx-select-box>
      <dx-button (onClick)="enregistrerTheme()" [disabled]="isSavingTheme">Enregistrer</dx-button>
    </div>
  </div>
  <div class="dx-field">
    <div class="dx-field-label">Personnalisation grille</div>
    <div class="dx-field-value">
      <dx-button text="Supprimer les préférences de grilles" (onClick)="onSupprimerStateStorage()"></dx-button>
    </div>
  </div>
</div>